import {
  Account,
  ConsistencyRules,
  ConsistencyRulesValues,
} from '@monorepo/types';
import { ACCOUNT_QUERY_KEYS, ACCOUNT_STALE_TIME } from '../constants';

/**
 * Creates a React Query configuration for fetching consistency rule data.
 *
 * @param accountStore - The account store instance with getConsistencyRule method
 * @param account - The account to fetch consistency rule for
 * @param rule - The specific consistency rule to fetch
 * @returns React Query configuration object
 */
export const createConsistencyRuleQuery = (
  accountStore: {
    getConsistencyRule: (
      tsAccountId: string,
      rule: ConsistencyRules,
    ) => Promise<ConsistencyRulesValues>;
  },
  account: Account | undefined,
  rule: ConsistencyRules,
) => ({
  queryKey: ACCOUNT_QUERY_KEYS.CONSISTENCY_RULE(
    account?.tsAccountId || '',
    rule,
  ),
  queryFn: async () => {
    if (!account?.tsAccountId) throw new Error('Account ID is required');
    return accountStore.getConsistencyRule(account.tsAccountId, rule);
  },
  staleTime: ACCOUNT_STALE_TIME,
  enabled: !!account?.tsAccountId,
});
